
const states = {
  IDLE: 'idle',
  ACTIVE: 'active',
  LEARNING: 'learning'
}

export default states